import Vue from "vue";

import LabelWrapper from "./LabelWrapper";
import CheckboxWrapper from "./CheckboxWrapper";

Vue.component("elwrapper", LabelWrapper);
Vue.component("CheckboxWrapper", CheckboxWrapper);
